// Generated by Melange

import * as JsxRuntime from "react/jsx-runtime";

function ScrollableFlexItem(Props) {
  let children = Props.children;
  return JsxRuntime.jsx("div", {
              children: children,
              className: "overflow-auto flex-1"
            });
}

const make = ScrollableFlexItem;

export {
  make ,
}
/* react/jsx-runtime Not a pure module */
